/* ============================================================
   SORVEN — behaviour layer

   Everything is delegated off `document`, so sections re-rendered
   by the theme editor keep working without re-binding. Scoped to
   .sorven wrappers; touches nothing else in the theme.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Money ---------------------------------------------------------- */
  function money(cents) {
    var fmt = window.SorvenMoneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ---- Product page state, keyed per section -------------------------- */
  var state = {};

  function root(el) { return el.closest('.sorven'); }

  function ctx(el) {
    var r = root(el);
    if (!r) return null;
    var id = r.id || 'sv-global';
    if (!state[id]) {
      var tag = $('[data-sv-variants]', r);
      state[id] = {
        el: r,
        variants: tag ? JSON.parse(tag.textContent) : [],
        options: [],
        qty: 1,
        bundleQty: 1,
        bundleTotal: 0,
        bundleBase: 0
      };
      /* seed selected options from the pre-selected buttons */
      $$('[data-sv-opt]', r).forEach(function (b) {
        if (b.classList.contains('is-on')) {
          state[id].options[Number(b.dataset.svOpt)] = b.dataset.svValue;
        }
      });
      var chosen = $('[data-sv-bundle].is-on', r);
      if (chosen) {
        state[id].bundleQty = Number(chosen.dataset.svQty) || 1;
        state[id].bundleTotal = Number(chosen.dataset.svTotal) || 0;
        state[id].bundleBase = Number(chosen.dataset.svBase) || 0;
      }
    }
    return state[id];
  }

  function currentVariant(s) {
    if (!s.variants.length) return null;
    if (!s.options.length) return s.variants[0];
    for (var i = 0; i < s.variants.length; i++) {
      var v = s.variants[i], ok = true;
      for (var j = 0; j < s.options.length; j++) {
        if (s.options[j] != null && v.options[j] !== s.options[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function sync(s) {
    var r = s.el, v = currentVariant(s);
    if (!v) return;

    var idInput = $('[data-sv-variant-id]', r);
    if (idInput) idInput.value = v.id;

    var priceEl = $('[data-sv-price]', r);
    if (priceEl) priceEl.textContent = money(v.price);

    var cmp = $('[data-sv-compare]', r), off = $('[data-sv-off]', r);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = money(v.compare_at_price); }
    if (off)  { off.hidden = !onSale; if (onSale) off.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% off'; }

    /* Bundle tiles reprice against the selected variant.
       data-sv-total is the exact figure the cart will charge, computed
       server-side against data-sv-base. If the shopper picks a variant at a
       different price that figure no longer holds, so fall back to the plain
       quantity x price rather than showing a total checkout won't honour. */
    $$('[data-sv-bundle]', r).forEach(function (t) {
      var q = Number(t.dataset.svQty) || 1;
      var base = Number(t.dataset.svBase);
      var total = Number(t.dataset.svTotal);
      var gross = v.price * q;
      var net = (total && base === v.price) ? total : gross;
      var n = $('[data-sv-net]', t), g = $('[data-sv-gross]', t), p = $('[data-sv-per]', t);
      if (n) n.textContent = money(net);
      if (g) g.textContent = (net < gross) ? money(gross) : '';
      if (p) p.textContent = money(Math.round(net / q));
    });

    /* Quantity = bundle quantity × stepper */
    var total = s.bundleQty * s.qty;
    var qi = $('[data-sv-qtyinput]', r);
    if (qi) qi.value = total;
    var qv = $('[data-sv-qtyval]', r);
    if (qv) qv.textContent = s.qty;
    var minus = $('[data-sv-qtystep="-1"]', r);
    if (minus) minus.disabled = s.qty <= 1;

    /* Add-to-cart label + running total */
    var gross2 = v.price * total;
    /* What the cart will actually charge.

       The bundle discount in Shopify is an amount off the order, applied
       once, above a minimum quantity of the product — it is not a
       multiplier. This used to read bundleTotal * qty, which promised the
       pack price again for every step of the quantity control: four
       WakeBand Pro were quoted at 159.98 while the cart charged 199.97,
       because the 39.99 only ever comes off once. It missed the opposite
       case too — a single pack stepped up to two units qualifies for that
       same discount, and the page quoted more than the cart would take.

       So the threshold is read from the pack tiles themselves rather than
       from the selected one alone, and applied once to the real unit
       count (total, computed above). A tile total is still only trusted for the variant it was
       computed against. */
    var bundleSaving = 0;
    $$('[data-sv-bundle]', r).forEach(function (t) {
      var q = Number(t.dataset.svQty) || 1;
      var tot = Number(t.dataset.svTotal);
      var base = Number(t.dataset.svBase);
      if (q > 1 && tot && base === v.price && total >= q) {
        var sav = (v.price * q) - tot;
        if (sav > bundleSaving) bundleSaving = sav;
      }
    });
    var net2 = Math.round((v.price * total) - bundleSaving);
    /* What this selection saves against the recommended price. Derived from
       the same net2 the add-to-cart button quotes, so the saving, the price
       and the amount actually charged are all one number — and it is hidden
       rather than shown as zero when the variant is not on sale. */
    var save = $('[data-sv-save]', r);
    if (save) {
      var rrp = (v.compare_at_price || 0) * total;
      var savedAmt = rrp - net2;
      var showSave = onSale && savedAmt > 0;
      save.hidden = !showSave;
      if (showSave) save.innerHTML = 'You save <b>' + money(savedAmt) + '</b> today';
    }

    var atc = $('[data-sv-atc]', r);
    var lbl = $('[data-sv-atc-label]', r);
    var tot = $('[data-sv-atc-total]', r);
    if (atc) atc.disabled = !v.available;
    if (lbl) lbl.textContent = v.available ? (atc.dataset.svLabel || lbl.textContent.trim() || 'Add to bag') : 'Sold out';
    if (tot) tot.textContent = v.available ? ' · ' + money(net2) : '';

    /* Option labels */
    $$('[data-sv-optval]', r).forEach(function (el, i) {
      if (s.options[i]) el.textContent = '· ' + s.options[i];
    });

    /* Mobile sticky bar.
       Written from the values this pass just computed rather than from its
       own copy of the pricing rules, so the bar can never quote a price the
       buy box disagrees with. */
    var sticky = $('[data-sv-sticky]', r) || document.querySelector('[data-sv-sticky]');
    if (sticky) {
      var sPrice = $('[data-sv-sticky-price]', sticky);
      var sMeta = $('[data-sv-sticky-meta]', sticky);
      var sBtn = $('[data-sv-sticky-add]', sticky);
      var sLbl = $('[data-sv-sticky-label]', sticky);

      if (sPrice) sPrice.textContent = v.available ? money(net2) : '';

      if (sMeta) {
        /* "2-pack · Black" — the chosen bundle plus the chosen options, which
           is what the customer needs to confirm before committing. */
        var bits = [];
        var onTile = $('[data-sv-bundle].is-on', r);
        if (onTile) {
          var nm = $('.tile__name', onTile);
          if (nm) bits.push(nm.textContent.replace(/\s+/g, ' ').trim().split('Save')[0].trim());
        }
        if (s.qty > 1) bits.push('×' + s.qty);
        s.options.forEach(function (o) { if (o) bits.push(o); });
        sMeta.textContent = bits.join(' · ');
      }

      if (sBtn) sBtn.disabled = !v.available;
      if (sLbl && !sticky.dataset.svBusy) {
        sLbl.innerHTML = v.available ? 'Add to cart &rarr;' : 'Sold out';
      }
    }
  }

  /* ---- Price-drop entrance --------------------------------------------
     Runs once per product form, the moment the page first has it — never
     again on a later variant/bundle change. A variant click only ever
     calls sync() directly (see the click handler below), never boot(),
     so this function is simply never in that path; nothing needs to
     distinguish "first load" from "variant change" beyond that.

     sync() has already written the correct final price into the DOM by
     the time this runs (boot() calls it first, synchronously, on the
     same pass) — this only ever OVERWRITES that text temporarily, frame
     by frame, and its very last write is the same money(v.price) sync()
     already produced. If anything here is skipped, the correct price is
     simply what is already showing. */
  var PRICE_DROP_DURATION = 1500;

  function armPriceDrop(s) {
    var wrap = $('[data-sv-price-drop]', s.el);
    if (!wrap || wrap._svPriceDropDone) return;
    wrap._svPriceDropDone = true;

    var live = $('[data-sv-price]', wrap);
    var v = currentVariant(s);
    if (!live || !v) return;

    /* Same on-sale condition sync() already used to decide whether the
       compare-at strike-through shows at all. */
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (!onSale) return;

    var reduceMQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMQ && reduceMQ.matches) return;   // sync() already left the real price in place

    var from = v.compare_at_price, to = v.price, delta = from - to, start = null;
    function frame(now) {
      /* Checked every frame, not just once, so switching reduced motion on
         mid-count settles immediately instead of finishing the animation. */
      if (reduceMQ && reduceMQ.matches) { live.textContent = money(to); return; }
      if (start === null) start = now;
      var t = Math.min((now - start) / PRICE_DROP_DURATION, 1);
      if (t >= 1) { live.textContent = money(to); return; }   // exact cents, no interpolation drift
      var eased = 1 - Math.pow(1 - t, 3);
      live.textContent = money(Math.round(from - delta * eased));
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---- Gallery -------------------------------------------------------- */
  function goSlide(r, n) {
    var slides = $$('[data-sv-slide]', r), thumbs = $$('[data-sv-thumb]', r);
    if (!slides.length) return;
    var i = ((n % slides.length) + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    /* Thumbnails are matched on the slide index they carry, not on their own
       position, because they are allowed to be a subset of the slides: the
       3D slide has no thumbnail of its own, so thumbnail 0 belongs to slide
       1. Pairing by position would light the wrong thumbnail for every
       image on the page. When the 3D slide is showing, none match, which is
       correct — there is nothing in the strip representing it. */
    thumbs.forEach(function (t) {
      t.classList.toggle('is-on', Number(t.dataset.svThumb) === i);
    });
    r.dataset.svIndex = i;
    if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  /* ---- Delegated events ----------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Gallery arrows */
    var arrow = t.closest('[data-sv-gal]');
    if (arrow) {
      var r = root(arrow);
      goSlide(r, (Number(r.dataset.svIndex) || 0) + Number(arrow.dataset.svGal));
      return;
    }

    /* Gallery thumbs */
    var thumb = t.closest('[data-sv-thumb]');
    if (thumb) { goSlide(root(thumb), Number(thumb.dataset.svThumb)); return; }

    /* Variant options */
    var opt = t.closest('[data-sv-opt]');
    if (opt) {
      var s = ctx(opt);
      var idx = Number(opt.dataset.svOpt);
      s.options[idx] = opt.dataset.svValue;
      $$('[data-sv-opt="' + idx + '"]', s.el).forEach(function (o) { o.classList.toggle('is-on', o === opt); });
      sync(s);
      return;
    }

    /* Bundle tiles */
    var tile = t.closest('[data-sv-bundle]');
    if (tile) {
      var s2 = ctx(tile);
      s2.bundleQty = Number(tile.dataset.svQty) || 1;
      s2.bundleTotal = Number(tile.dataset.svTotal) || 0;
      s2.bundleBase = Number(tile.dataset.svBase) || 0;
      $$('[data-sv-bundle]', s2.el).forEach(function (o) { o.classList.toggle('is-on', o === tile); });
      sync(s2);
      return;
    }

    /* Quantity stepper */
    var step = t.closest('[data-sv-qtystep]');
    if (step) {
      var s3 = ctx(step);
      s3.qty = Math.max(1, Math.min(20, s3.qty + Number(step.dataset.svQtystep)));
      sync(s3);
      return;
    }

    /* FAQ accordion */
    var q = t.closest('.faq__q');
    if (q) {
      var item = q.closest('.faq__item');
      var open = item.classList.contains('is-open');
      item.classList.toggle('is-open', !open);
      q.setAttribute('aria-expanded', String(!open));
      return;
    }

    /* Shop grid tabs */
    var tab = t.closest('[data-sv-tab]');
    if (tab) {
      var wrap = root(tab);
      $$('[data-sv-tab]', wrap).forEach(function (o) {
        var on = o === tab;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-selected', String(on));
      });
      $$('[data-sv-panel]', wrap).forEach(function (p) {
        p.hidden = p.dataset.svPanel !== tab.dataset.svTab;
      });
      return;
    }
  });

  /* Gallery swipe.

     A drag that starts on the 3D viewer is a rotation, not a swipe. Its
     pointer events bubble up to the stage like any other, so without this
     the same gesture would spin the model AND advance the gallery past it.
     Leaving svX unset here is enough — the pointerup below already bails
     when there is no start position recorded. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest('[data-sv-3d]')) return;
    var stage = e.target.closest('[data-sv-gallery]');
    if (stage) stage.dataset.svX = e.clientX;
  });
  document.addEventListener('pointerup', function (e) {
    var stage = e.target.closest('[data-sv-gallery]');
    if (!stage || stage.dataset.svX == null) return;
    var d = e.clientX - Number(stage.dataset.svX);
    delete stage.dataset.svX;
    if (Math.abs(d) > 44) {
      var r = root(stage);
      goSlide(r, (Number(r.dataset.svIndex) || 0) + (d < 0 ? 1 : -1));
    }
  });

  /* ---- Reveal on scroll ------------------------------------------------
     Only elements already below the fold are hidden, so the page reads
     complete at rest and in link previews. */
  function initReveal(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var sel = ['.sec-head', '.proof__top', '.ugc', '.logobar', '.pspanel', '.bcard', '.step',
               '.cmp-scroll', '.radial', '.ingr', '.spec', '.faq__item', '.gtee__seal',
               '.gtee__copy', '.fcta__media', '.fcta__copy', '.pcard', '.spot', '.duocard', '.tcard']
              .map(function (s) { return '.sorven ' + s; }).join(',');
    var els = $$(sel, scope).filter(function (el) {
      return el.getBoundingClientRect().top > window.innerHeight * 0.9 && !el.classList.contains('rev');
    });
    /* Image-led blocks get the slightly cinematic variant (a touch of scale
       on top of the lift) rather than the plain text reveal. Kept to this
       short list on purpose — applied to every image the page would feel
       busy rather than composed. */
    var imgLed = '.fcta__media,.spot,.ugc,.gtee__seal';
    els.forEach(function (el) {
      el.classList.add('pre', 'rev');
      if (el.matches(imgLed)) el.classList.add('sv-img');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sibs = Array.prototype.filter.call(e.target.parentElement.children, function (c) {
          return c.classList.contains('pre');
        });
        e.target.style.transitionDelay = Math.min(sibs.indexOf(e.target), 5) * 80 + 'ms';
        e.target.classList.remove('pre');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Boot ----------------------------------------------------------- */
  function boot(scope) {
    $$('.sorven [data-sv-variants]', scope).forEach(function (tag) {
      var s = ctx(tag);
      if (s) { sync(s); armPriceDrop(s); }
    });
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Theme editor re-renders a section: rebuild its state and re-sync. */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.sorven');
    if (r && r.id) delete state[r.id];
    boot(e.target);
  });
})();

/* ============================================================
   SORVEN — feature rotator + social video embeds
   Separate IIFE so it can't interfere with the buy-box state above.
   ============================================================ */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Feature rotator ---------------------------------------------- */
  function initRotator(root) {
    var items = $$('[data-sv-feat]', root);
    var shots = $$('[data-sv-shot]', root);
    if (!items.length) return;
    var i = 0, timer = null;
    var interval = Number(root.dataset.svInterval) || 5000;

    function show(n) {
      i = ((n % items.length) + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
      shots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
    }
    function start() {
      if (reduce) return;
      stop();
      timer = setInterval(function () { show(i + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    items.forEach(function (el, k) {
      el.addEventListener('click', function () { show(k); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    /* Only run while on screen — no timers burning in background tabs. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else { start(); }
  }

  /* ---- Click-to-play external video --------------------------------- */
  function toEmbed(url) {
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  document.addEventListener('click', function (e) {
    var host = e.target.closest('[data-sv-video-embed]');
    if (!host || host.querySelector('iframe')) return;
    var src = toEmbed(host.dataset.src || '');
    if (!src) return;
    var f = document.createElement('iframe');
    f.src = src;
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', 'Video');
    f.loading = 'lazy';
    host.innerHTML = '';
    host.appendChild(f);
  });

  function boot(scope) { $$('[data-sv-rotator]', scope).forEach(initRotator); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* ============================================================
   SORVEN — stat count-up
   ------------------------------------------------------------
   Animates the homepage stat figures from zero to their real
   values the first time the block scrolls into view.

   The markup ships with the finished value already rendered and
   a hidden ghost copy holding the layout at final width, so this
   file only ever has to touch the visible copy — nothing here is
   load-bearing for the number being correct, and nothing it does
   can move the surrounding layout.
   ============================================================ */
(function () {
  'use strict';

  /* Read the preference at arm time rather than latching it into a
     module-level early return. The old version bailed out of the whole
     feature on load, so a desktop with "reduce motion" switched on in the
     OS got no counter at all while the same person's phone did — which is
     exactly the shape of "works on mobile, not on desktop". Under reduced
     motion the numbers are simply left at their authored values, which is
     the correct outcome, not a broken one. */
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reducedNow() { return !!(mq && mq.matches); }

  var DURATION = 1400;
  var STAGGER = 90;

  /* Values are merchant-typed free text: "4.8 / 5", "4,000+", "14 days",
     "0 dB". Pull out the first number and keep whatever surrounds it, so
     the units and separators come back exactly as they were authored. */
  function parse(text) {
    var m = text.match(/\d[\d,]*(?:\.\d+)?/);
    if (!m) return null;
    var raw = m[0];
    var dot = raw.indexOf('.');
    return {
      target: parseFloat(raw.replace(/,/g, '')),
      decimals: dot === -1 ? 0 : raw.length - dot - 1,
      grouped: raw.indexOf(',') !== -1,
      pre: text.slice(0, m.index),
      post: text.slice(m.index + raw.length)
    };
  }

  function format(value, spec) {
    var s = value.toFixed(spec.decimals);
    if (spec.grouped) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return spec.pre + s + spec.post;
  }

  function run(entry) {
    var live = entry.live, spec = entry.spec, duration = entry.duration || DURATION;
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      live.textContent = format(spec.target * eased, spec);
      if (t < 1) requestAnimationFrame(frame);
      else live.textContent = format(spec.target, spec);
    }
    requestAnimationFrame(frame);
  }

  /* Pending counters, in document order so the stagger reads left to right. */
  var pending = [];

  function settle(entry) {
    entry.done = true;
    entry.live.textContent = format(entry.spec.target, entry.spec);
  }

  /* Deliberately a rAF-throttled scroll check rather than an
     IntersectionObserver, matching the sticky add-to-cart above and for the
     same reason documented there: IO callbacks only run while the document
     is actually being rendered, so an occluded or backgrounded window can
     leave a counter armed at zero and never fire it. A rect read on scroll
     has no such dependency and costs one layout read per frame, only while
     the page is actually moving. */
  var ticking = false;
  function evaluate() {
    ticking = false;
    if (!pending.length) return;

    var line = window.innerHeight * 0.88;
    var fired = 0;
    for (var i = 0; i < pending.length; i++) {
      var entry = pending[i];
      if (entry.done) continue;
      if (entry.node.getBoundingClientRect().top > line) continue;

      entry.done = true;
      if (reducedNow() || entry.spec.target === 0) {
        /* Reduced motion, or the "0 dB" stat that has nothing to count to:
           put the authored value straight back rather than animating. */
        settle(entry);
      } else {
        entry.timer = setTimeout(run, fired * STAGGER, entry);
        fired++;
      }
    }
    pending = pending.filter(function (e) { return !e.done; });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(evaluate);
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sv-count]');
    if (!nodes.length) return;

    Array.prototype.forEach.call(nodes, function (node) {
      if (node._svCountBound) return;
      node._svCountBound = true;

      var live = node.querySelector('.stat__n-live');
      if (!live) return;
      var spec = parse(live.textContent.trim());
      if (!spec) return;

      /* Per-instance duration override — e.g. the guarantee seal wants a
         slower ~2.25s count rather than the 1.4s default used for the
         compact homepage stat figures. Omit the attribute to get the
         default, so every existing call site is unaffected. */
      var duration = Number(node.dataset.svCountDuration) || DURATION;
      var entry = { node: node, live: live, spec: spec, duration: duration, done: false };

      /* Only ever blank a number that is still below the fold. Anything
         already on screen — or already scrolled past, on a deep link or a
         restored scroll position — keeps its authored value, so a missed
         trigger can never strand a stat displaying zero. */
      if (!reducedNow() && spec.target !== 0 &&
          node.getBoundingClientRect().top > window.innerHeight * 0.88) {
        live.textContent = format(0, spec);
        pending.push(entry);
      }
    });

    if (pending.length) onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* If the customer switches reduce-motion on mid-visit, stop animating and
     show every outstanding figure immediately rather than leaving zeros. */
  if (mq && mq.addEventListener) {
    mq.addEventListener('change', function () {
      if (!mq.matches) return;
      pending.forEach(function (e) { clearTimeout(e.timer); settle(e); });
      pending = [];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ============================================================
   SORVEN — mobile sticky add to cart
   ------------------------------------------------------------
   Phone only. Reveals once the real buy box leaves the viewport
   and hides again the moment it comes back, so there is never
   more than one live call to action on screen.

   Adding to cart submits the ACTUAL product form's FormData to
   Shopify's cart API, so the variant, quantity and any line item
   properties are exactly what the buy box would have sent. No
   second source of truth for what gets added.

   Price and bundle text are written by sync() above.
   ============================================================ */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sv-sticky]');
  if (!bar) return;

  var form = document.getElementById('sv-form');
  var realBtn = document.querySelector('[data-sv-atc]');
  var btn = bar.querySelector('[data-sv-sticky-add]');
  var lbl = bar.querySelector('[data-sv-sticky-label]');
  if (!form || !realBtn || !btn) return;

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal ------------------------------------------------------- */
  function show(on) {
    bar.hidden = !on;
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    bar.classList.toggle('is-in', on);
  }

  /* Deliberately a scroll/resize check rather than an IntersectionObserver.
     IO callbacks only run while the document is actually being rendered, so
     a backgrounded or occluded tab can leave the bar stuck in whatever state
     it was last in. Reading the rect on a rAF-throttled scroll is cheap and
     has no such dependency. */
  var ticking = false;
  function evaluate() {
    ticking = false;
    var r = realBtn.getBoundingClientRect();
    /* Only once the buy box is BEHIND the customer. Firing on "not visible"
       would also show the bar on first paint, while the real button is
       simply further down the page and has not been reached yet — two live
       calls to action for the same thing, one of them premature. */
    show(r.bottom <= 0);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(evaluate);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  evaluate();

  /* ---- add ---------------------------------------------------------- */
  function routes(file) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + file;
  }

  function openDrawer() {
    /* Use whatever drawer the theme already ships. If there isn't one, the
       header bag count still updates and we simply leave the customer where
       they are rather than yanking them to /cart. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    var opener = document.querySelector('[data-sv-cart-open], .header__icon--cart');
    if (drawer && opener) { opener.click(); return true; }
    return false;
  }

  btn.addEventListener('click', function () {
    if (btn.disabled) return;

    var data = new FormData(form);
    data.append('sections_url', window.location.pathname);

    bar.dataset.svBusy = '1';
    btn.disabled = true;
    lbl.textContent = 'Adding…';

    fetch(routes('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add failed'); });
        return r.json();
      })
      .then(function () {
        lbl.innerHTML = '&#10003; Added';
        bar.classList.add('is-done');

        // Refresh the header bag count the way the theme does elsewhere.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var items = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();

        setTimeout(function () { openDrawer(); }, reduced ? 0 : 260);

        setTimeout(function () {
          bar.classList.remove('is-done');
          delete bar.dataset.svBusy;
          btn.disabled = false;
          lbl.innerHTML = 'Add to cart &rarr;';
        }, 2200);
      })
      .catch(function (err) {
        lbl.textContent = 'Try again';
        bar.classList.add('is-err');
        setTimeout(function () {
          bar.classList.remove('is-err');
          delete bar.dataset.svBusy;
          btn.disabled = false;
          lbl.innerHTML = 'Add to cart &rarr;';
        }, 2200);
        if (window.console) console.warn('[sorven] sticky add to cart:', err.message);
      });
  });
})();

/* ============================================================
   SORVEN — hero parallax
   ------------------------------------------------------------
   Depth between the hero photograph and the text over it: the
   background travels a little slower than the page, the copy a
   little faster, and both stop moving the moment the hero has
   left the screen.

   Written to two custom properties rather than to inline
   transforms, so the transform itself stays owned by the
   stylesheet (see "A5" in sorven-pass3.css) and this can never
   fight a CSS rule for the same property.

   Vertical only — nothing here can create horizontal overflow.
   ============================================================ */
(function () {
  'use strict';

  var hero = document.querySelector('.sorven .ehero');
  if (!hero) return;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  /* Deliberately small. The background moves at 6% of scroll distance and
     the copy at 3% in the opposite sense, which is enough to read as depth
     and not enough to notice as movement. */
  var BG = 0.06, FG = -0.03, MAX = 44;

  var ticking = false;
  var applied = false;

  function clamp(v) { return v < -MAX ? -MAX : (v > MAX ? MAX : v); }

  function frame() {
    ticking = false;

    if (mq && mq.matches) {
      if (applied) {
        hero.style.removeProperty('--sv-par-bg');
        hero.style.removeProperty('--sv-par-fg');
        applied = false;
      }
      return;
    }

    var r = hero.getBoundingClientRect();
    /* Once the hero is off screen there is nothing to parallax, and
       continuing to write properties would keep invalidating style for a
       section nobody can see. */
    if (r.bottom <= 0 || r.top >= window.innerHeight) return;

    var travelled = Math.max(0, -r.top);
    hero.style.setProperty('--sv-par-bg', clamp(travelled * BG).toFixed(2) + 'px');
    hero.style.setProperty('--sv-par-fg', clamp(travelled * FG).toFixed(2) + 'px');
    applied = true;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (mq && mq.addEventListener) mq.addEventListener('change', onScroll);
  onScroll();
})();
